import React, { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import { Provider as JotaiProvider } from "jotai";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorPage } from "./ErrorPage";
import { store } from "./redux/store";
import "./App.scss";
import 'rc-slider/assets/index.css';

const About = lazy(() => import("./pages/About/About"));
const MdApp = lazy(() => import("./apps/md/MdApp"));
const ExpApp = lazy(() => import("./apps/experiment/ExperimentRoot"));

function App() {
  const isExpRoot = process.env?.REACT_APP_ROOT === 'exp';
  const RootApp = isExpRoot ? ExpApp : MdApp;
  
  const app = (
    <Provider store={store}>
      <JotaiProvider>
        <div className="app">
          <BrowserRouter>
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                <Route path="/" element={<RootApp />} />
                <Route path="md" element={<MdApp />} />
                <Route path="exp/*" element={<ExpApp />} />
                <Route path="about" element={<About />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </div>
      </JotaiProvider>
    </Provider>
  );

  return <ErrorBoundary FallbackComponent={ErrorPage}>{app}</ErrorBoundary>;
}

export default App;
